import EnableFeeBanner from 'components/enableFeeBanner';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { selectIsVerifiedIndianUser } from 'selectors/user';
import { useAppSelector } from 'storeHooks';

const ProfileMenuMarketingBanner = () => {
  const isVerifiedIndianUser = useAppSelector(selectIsVerifiedIndianUser);

  return isVerifiedIndianUser && !IS_INDIAN_EXCHANGE ? null : <EnableFeeBanner />;
};

export { ProfileMenuMarketingBanner };
